<script setup>
// The bot's four numbers, as the kit's tiles. A rate with no conversation behind it was not measured: "-" (7-10);
// a count the backend measured as zero stays 0.
import { computed, ref, watch, onMounted } from 'vue';
import ReportsAPI from 'dashboard/api/reports';
import StatTile from 'dashboard/components-next/polaris/cards/StatTile.vue';

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
});

const metrics = ref(null);
const isLoading = ref(false);

const measured = computed(() => metrics.value?.conversation_count > 0);
const count = key =>
  metrics.value ? metrics.value[key].toLocaleString() : '-';
const rate = key => (measured.value ? `${metrics.value[key]}%` : '-');

const fetchMetrics = () => {
  if (!props.filters.to || !props.filters.from) {
    return;
  }
  isLoading.value = true;
  ReportsAPI.getBotMetrics(props.filters)
    .then(response => {
      metrics.value = response.data;
    })
    .finally(() => {
      isLoading.value = false;
    });
};

watch(() => props.filters, fetchMetrics, { deep: true });

onMounted(fetchMetrics);
</script>

<template>
  <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-bot-metrics>
    <StatTile
      :label="$t('BOT_REPORTS.METRIC.TOTAL_CONVERSATIONS.LABEL')"
      :info="$t('BOT_REPORTS.METRIC.TOTAL_CONVERSATIONS.TOOLTIP')"
      :value="count('conversation_count')"
      :loading="isLoading"
    />
    <StatTile
      :label="$t('BOT_REPORTS.METRIC.TOTAL_RESPONSES.LABEL')"
      :info="$t('BOT_REPORTS.METRIC.TOTAL_RESPONSES.TOOLTIP')"
      :value="count('message_count')"
      :loading="isLoading"
    />
    <StatTile
      :label="$t('BOT_REPORTS.METRIC.RESOLUTION_RATE.LABEL')"
      :info="$t('BOT_REPORTS.METRIC.RESOLUTION_RATE.TOOLTIP')"
      :value="rate('resolution_rate')"
      :loading="isLoading"
    />
    <StatTile
      :label="$t('BOT_REPORTS.METRIC.HANDOFF_RATE.LABEL')"
      :info="$t('BOT_REPORTS.METRIC.HANDOFF_RATE.TOOLTIP')"
      :value="rate('handoff_rate')"
      :loading="isLoading"
    />
  </div>
</template>
